import React from 'react';
import PropTypes from 'prop-types';
import './index.less';

const BaseIcon = props => {
    const {srcset = '', sizes = '', src = '', alt} = props;
    return (
        <span className="img-icon-container">
            <img srcSet={srcset} sizes={sizes} src={src} alt={alt} className="img-icon" />
        </span>
    );
};

BaseIcon.defaultProps = {
    src: '',
    srcset: '',
    sizes: '',
};

BaseIcon.propTypes = {
    srcset: PropTypes.string,
    sizes: PropTypes.string,
    src: PropTypes.string,
    alt: PropTypes.string.isRequired,
};

export default BaseIcon;
